var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleGraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_5465_5542)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5465_5542)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5254 16.5234V43.4734H43.4752V40.9068H19.0919V16.5234H16.5254ZM37.0907 30.9336L41.8951 22.9763L38.5992 20.9863L34.6566 27.5163L28.7348 25.0127L27.3236 24.4161L26.4255 25.6574L21.3209 32.7137L24.4402 34.9703L28.6468 29.1553L34.6931 31.7116L36.2289 32.3609L37.0907 30.9336Z",
    fill: "url(#paint1_linear_5465_5542)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5465_5542",
    x1: 0,
    y1: 0,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB421"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA5A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5465_5542",
    x1: 30.0003,
    y1: 16.5234,
    x2: 30.0003,
    y2: 43.4734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.9
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5465_5542"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.5,
    height: 27.5,
    fill: "white",
    transform: "translate(16.25 16.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGraph);
export default __webpack_public_path__ + "static/media/circle-graph.ed4ee8b141943754d046397dba1bfce0.svg";
export { ForwardRef as ReactComponent };